import { createSlice } from '@reduxjs/toolkit'

import { AppThunk } from '../store'
import { postLangStatus } from '../../apis/common'
import { updateCompanyLang, setStateLanguage } from './commonPartSlice'
import { setErrors } from './errorsSlice'

import { PostLangStatusParams } from '../../types/setting'

interface LangStatusState {
  isLoading: boolean
}

const initialState: LangStatusState = {
  isLoading: false,
}

const langStatusSlice = createSlice({
  name: 'langStatus',
  initialState,
  reducers: {
    requestStart: (state: LangStatusState) => {
      state.isLoading = true
      return state
    },
    postLangStatusSuccess: (state: LangStatusState) => {
      state.isLoading = false
      return state
    },
    requestFailure: (state: LangStatusState) => {
      state.isLoading = false
      return state
    },
  },
})

export const {
  requestStart,
  postLangStatusSuccess,
  requestFailure,
} = langStatusSlice.actions

export const langStatusReducer = langStatusSlice.reducer

export const updateLangStatus = (
  params: PostLangStatusParams,
  callback: () => void,
): AppThunk => async (dispatch) => {
  requestStart()
  postLangStatus(params)
    .then(() => {
      postLangStatusSuccess()
      dispatch(updateCompanyLang(params))
      dispatch(setStateLanguage(params.language))
      callback()
    })
    .catch((error) => {
      dispatch(requestFailure())
      dispatch(setErrors(error))
    })
}
